"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COUNTIFS = void 0;
exports.COUNTIFS = {
    alias: 'CONTARSES',
    description: 'Conta a quantidade de valores do intervalo selecionado que atendem aos critérios especificados, avaliando múltiplas condições como um "E" lógico.',
    arg_names: ['coluna_a_contar', 'condicao', 'outras_condicoes'],
    args_description: ['coluna a contar', 'condição de match', 'outras condições de match'],
};
